import React from 'react';

export const ErrorPlaceholder: React.FC<{ error: Error }> = ({ error }) => (
  <div className="error">
    <h2>Something went wrong</h2>
    <pre>{error.stack ?? error.message}</pre>
  </div>
);
